import { getCDNUrl, getStaticPathFromClientOrWeb } from '~/utils/utils';
import { t } from '~/utils/localization';
import { CATEGORIES } from '~/const';
import store from '~/Store';

export const SANTA_SIZE: Record<string, string> = {
    santa_1: 'small',
    santa_2: 'medium',
    santa_3: 'big',
    santa_certificate_1: 'small',
    santa_certificate_2: 'medium',
    santa_certificate_3: 'big',
};

export const DEFAULT_SELECTED_INDEX_BY_GROUP: Record<string, number> = {
    santa_1: 2,
    santa_2: 2,
    santa_3: 2,
    santa_certificate_1: 1,
    santa_certificate_2: 1,
    santa_certificate_3: 1,
};

export const isSantaBundle = (bundle: IBundle): boolean => {
    const availableTypes = Object.keys(SANTA_SIZE) || [];

    return availableTypes.includes(bundle?.groupName);
};

export const SANTA_BUNDLES_AUDIO_MAP: any = {
    small: getCDNUrl('armory/01111/hover_effect_small_v4.mp3'),
    medium: getCDNUrl('armory/01111/hover_effect_medium_v4.mp3'),
    big: getCDNUrl('armory/01111/hover_effect_big_v1.mp3'),
};

export const SANTA_FOR_GOLD_BACKGROUND: IVideo = {
    mp4: getCDNUrl('armory/01111/gold_bg_v8.mp4'),
    webm: getCDNUrl('armory/01111/gold_bg_v8.webm'),
};

export const SANTA_FOR_CERTIFICATES_BACKGROUND: IVideo = {
    mp4: getCDNUrl('armory/01111/certificates_bg_v5.mp4'),
    webm: getCDNUrl('armory/01111/certificates_bg_v5.webm'),
};

export const SANTA_CONFIRM_PURCHASE_VIDEO: IVideo = {
    mp4: getCDNUrl('armory/01111/purchase_bg_v3.mp4'),
    webm: getCDNUrl('armory/01111/purchase_bg_v3.webm'),
};

type VideoAnimation = {
    idle: ReturnType<typeof getStaticPathFromClientOrWeb>;
    hover: ReturnType<typeof getStaticPathFromClientOrWeb>;
};
export const SANTA_BUNDLE_CARD_VIDEOS: Record<string, VideoAnimation> = {
    small: {
        idle: getCDNUrl('armory/01111/box1v10.webm', true),
        hover: getCDNUrl('armory/01111/box1.1v5.webm', true),
    },
    medium: {
        idle: getCDNUrl('armory/01111/box2v10.webm', true),
        hover: getCDNUrl('armory/01111/box2.1v6.webm', true),
    },
    big: {
        idle: getCDNUrl('armory/01111/box3v12.webm', true),
        hover: getCDNUrl('armory/01111/box3.1v8.webm', true),
    },
};

export const VIDEO_BUNDLE_PREVIEW: Record<string, Record<string, IVideo>> = {
    small: {
        intro: {
            webm: getStaticPathFromClientOrWeb({
                cdn: getCDNUrl('armory/01111/intro_small_bundle_v1.webm'),
                client: 'armory/ny23/intro_small_bundle_v1.webm',
            }),
            mp4: getCDNUrl('armory/01111/intro_small_bundle_v1.mp4'),
        },
        static: {
            webm: getCDNUrl('armory/01111/small_box_static_bg_v3.webm'),
            mp4: getCDNUrl('armory/01111/small_box_static_bg_v3.mp4'),
        },
    },
    medium: {
        intro: {
            webm: getStaticPathFromClientOrWeb({
                cdn: getCDNUrl('armory/01111/intro_medium_bundle_v1.webm'),
                client: 'armory/ny23/intro_medium_bundle_v1.webm',
            }),
            mp4: getCDNUrl('armory/01111/intro_small_bundle_v1.mp4'),
        },
        static: {
            webm: getCDNUrl('armory/01111/medium_box_static_bg_v3.webm'),
            mp4: getCDNUrl('armory/01111/medium_box_static_bg_v3.mp4'),
        },
    },
    big: {
        intro: {
            webm: getStaticPathFromClientOrWeb({
                cdn: getCDNUrl('armory/01111/intro_big_bundle_v1.webm'),
                client: 'armory/ny23/intro_big_bundle_v1.webm',
            }),
            mp4: getCDNUrl('armory/01111/intro_small_bundle_v1.mp4'),
        },
        static: {
            webm: getCDNUrl('armory/01111/big_box_static_bg_v3.webm'),
            mp4: getCDNUrl('armory/01111/big_box_static_bg_v3.mp4'),
        },
    },
};

export const isAvailableSwitcherBetweenSantaCategories = (categoryName: string) => {
    const { categories } = store.getState().ReducerApp;
    const categoriesNames = Object.keys(categories);
    const hasBothCategories = categoriesNames?.includes(CATEGORIES.SANTA_CONTAINERS) && categoriesNames?.includes(CATEGORIES.SANTA_CERTIFICATES);
    return (categoryName === CATEGORIES.SANTA_CERTIFICATES || categoryName === CATEGORIES.SANTA_CONTAINERS) && hasBothCategories;
};

export const isCertificateShowcase = (categoryName: string) => {
    return [CATEGORIES.SANTA_CERTIFICATES, CATEGORIES.SANTA_CERTIFICATES_ONLY].includes(categoryName);
};
